import { smoothScroll } from '@doltech/utils/lib/smooth-scroll';

import { LANDING_HEADER_HEIGHT } from '../../figma/Layout/Landing/constants';
import { useAppScrollRef } from '@doltech/core/lib/appScroll/withAppScroll';

const SCROLL_TOP_SPACING = 24;

export const useListingLandingHelper = () => {
  const { appScrollRef } = useAppScrollRef();
  const scrollToTopOfSection = (sectionId = 'listing-landing') => {
    const elmToScroll = document.getElementById(sectionId);
    const scrollContainer = appScrollRef.current;
    smoothScroll(
      300,
      scrollContainer,
      elmToScroll.offsetTop - LANDING_HEADER_HEIGHT - SCROLL_TOP_SPACING
    );
  };

  return {
    scrollToTopOfSection,
  };
};
